<template>
  <section>
    <el-form :model="formObj" :rules="fromRules" ref="formObj" label-width="120px">
      <el-form-item label="上级公司" prop="comParent">
        <div v-if="isShowTree">
          <CompanyList @comSelected="comSelected" :com-name="formObj.parentName" :com-id="formObj.comParent" :current-id="formObj.id" :option="option"></CompanyList>
        </div>
      </el-form-item>
      <el-form-item label="公司名称" prop="comName">
        <el-input v-model="formObj.comName" placeholder="请输入" maxlength="50" show-word-limit=""></el-input>
      </el-form-item>
      <el-form-item label="公司简介" prop="comDesc">
        <el-input type="textarea" v-model="formObj.comDesc" placeholder="请输入"  maxlength="200" show-word-limit=""></el-input>
      </el-form-item>
      <el-form-item label="公司LOGO" prop="comPhoto">
        <el-upload
          :action="this.GLOBAL.baseServerPath+'/imgupload'"
          :headers="this.GLOBAL.fileHeader"
          name="file"
          list-type="picture-card"
          :limit="1"
          :on-exceed="handleExceed"
          :on-remove="fileRemove"
          :on-success="fileSuccess"
          :file-list="fileList">
          <div class="pic_btn"><i class="el-icon-plus"></i></div>
        </el-upload>
      </el-form-item>
    </el-form>
    <div class="dialog-footer">
      <el-button @click.native="doCancel">取消</el-button>
      <el-button type="primary" @click.native="doSubmit(option)">确定</el-button>
    </div>
  </section>
</template>

<script>
  import CompanyList from './CompanyList'
  import {comCreate,comUpdate} from '../../api/api'

  export default {
    name: "CompanyForm",
    components: {CompanyList},
    props: {
      option: 0,
      formData:{}
    },
    data() {
      return {
        formObj: {comParent:0},//如果不选择上级公司默认为总公司
        fromRules: {
          comName: [
            {required: true, message: '请输入公司名', trigger: 'blur'}
          ],
          comDesc: [
            {required: true, message: '请输入公司简介', trigger: 'blur'}
          ],
        },
        fileList: [],
        isShowTree:false,
        comId:null,
        comName:null,
      }
    },
    methods: {
      //删除上传图片
      fileRemove(file, fileList) {
        this.formObj.comPhoto = '';
      },
      //图片上传成功
      fileSuccess(response, file, fileList) {
        this.formObj.comPhoto = response.data;
      },
      //上传限制
      handleExceed: function (files,fileList) {
        this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      doSubmit: function (option) {
        this.$refs.formObj.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {type: 'warning'}).then(() => {
              this.formObj.comParent = this.comId;
              this.formObj.parentName = this.comName;
              if (option == 0) {
                comCreate(this.formObj, this.GLOBAL.header).then(result => {
                  if (result.success) {
                    this.$message({
                      message: "添加成功",
                      type: 'success'
                    });
                    this.$emit('doSubmit');
                  }
                });
              }
              else if (option == 9) {
                comUpdate(this.formObj, this.GLOBAL.header).then(result => {
                  if (result.success) {
                    this.$message({
                      message: "修改成功",
                      type: 'success'
                    });
                    this.$emit('doSubmit');
                  }
                });
              }
            }).catch(() => {
            });
          }
        });
      },
      doCancel:function(){
        this.$emit('doCancel');
      },
      comSelected:function(id,value){
        this.comId = id;
        this.comName = value;
      }
    },
    mounted() {
      this.isShowTree=true;
      this.formObj = this.formData;
      if(this.formObj.comPhoto!=null && this.formObj.comPhoto!='') {
        this.fileList.push({url: this.GLOBAL.basePhotoPath + "" + this.formObj.comPhoto});
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/sysmanager/CompanyForm.vue